var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotFound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_8046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 96,
    height: 96,
    rx: 48,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_68_8046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1281 56.7405L15.3574 60.5112L28.5548 66.1672L34.2134 79.3672L37.9841 75.5965L36.0988 66.1672L44.9334 57.3325L54.5601 77.8765L58.1308 74.3059L54.9574 47.3112L62.4988 39.7672C63.0081 39.2752 63.4144 38.6867 63.694 38.036C63.9735 37.3853 64.1206 36.6855 64.1268 35.9773C64.1329 35.2692 63.998 34.5669 63.7298 33.9114C63.4616 33.256 63.0656 32.6605 62.5649 32.1598C62.0641 31.659 61.4686 31.263 60.8132 30.9948C60.1577 30.7266 59.4554 30.5917 58.7473 30.5979C58.0391 30.604 57.3393 30.7511 56.6886 31.0307C56.0379 31.3102 55.4494 31.7165 54.9574 32.2259L47.2161 39.9672L20.2214 36.7912L16.8481 40.1672L37.2321 49.9539L28.5574 58.6285L19.1281 56.7405Z",
    fill: "black",
    fillOpacity: 0.16
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.8333 60.0007C60.5666 59.9997 65.1635 58.4151 68.892 55.4993L80.6147 67.222L84.3853 63.4513L72.6627 51.7286C75.58 47.9998 77.1655 43.4018 77.1667 38.6673C77.1667 26.9047 67.596 17.334 55.8333 17.334C44.0707 17.334 34.5 26.9047 34.5 38.6673C34.5 50.43 44.0707 60.0007 55.8333 60.0007ZM55.8333 22.6673C64.6573 22.6673 71.8333 29.8433 71.8333 38.6673C71.8333 47.4913 64.6573 54.6673 55.8333 54.6673C47.0093 54.6673 39.8333 47.4913 39.8333 38.6673C39.8333 29.8433 47.0093 22.6673 55.8333 22.6673Z",
    fill: "#A3A3A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_8046"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 96,
    height: 96,
    rx: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_68_8046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5 20)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotFound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/not-found.42fb114fd192e05026f2957e769b514d.svg";